import { BaseRestApiEndpoint, ERestApiMethod } from "utils/api";

type TInput = { watchdogId: number };
type TOutput = boolean;

export default class DeleteWatchdogApiEndpoint extends BaseRestApiEndpoint<
  TInput,
  TOutput
> {
  method = ERestApiMethod.DELETE;

  resolveUri({ watchdogId }: TInput): string {
    return `/fe-api/watchdog/${watchdogId}`;
  }

  mapResponseData(): TOutput {
    return true;
  }
}
